// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   استایل‌های اصلی صفحه جزئیات دوره
   ================================================================ */

.vid-course {
  width: 70vw;
}

.coursed-container {
  background-color: white;
  border-radius: 16px;
}

.mobile-scroll-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 10px;
  background-color: white;
  border-radius: 0 0 16px 16px;
  box-shadow: 0px 3px 10px #e0e0e0;
}

.mobile-scroll-buttons .course-btn {
  flex: 0 0 auto;
}

.mobile-scroll-buttons {
  scrollbar-width: thin;
  scrollbar-color: #28a745 #e0e0e0;
}

.mobile-scroll-buttons::-webkit-scrollbar {
  height: 8px;
}

.mobile-scroll-buttons::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 10px;
}

.mobile-scroll-buttons::-webkit-scrollbar-thumb {
  background: #28a745;
  border-radius: 10px;
}

.upd-sz {
  width: 120px;
  background-color: #E8F1FF;
  color: rgba(0, 0, 0, 0.633);
}

.faq-item {
  border-bottom: 1px solid #e5e7eb;
}

.faq-question {
  width: 100%;
  background: none;
  border: none;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  cursor: pointer;
}

.faq-answer-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
}

.faq-answer-wrapper.open {
  grid-template-rows: 1fr;
}

.faq-answer {
  overflow: hidden;
}

.time-session {
  font-size: 13px;
  color: #28a745;
}

.number-part {
  background-color: #D8EEE3;
  border: 2px solid #95D3B4;
  width: 46px;
  height: 46px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold !important;
}

.fs-little {
  font-size: 13px;
}

.bb-detail {
  border-bottom: 1px solid #E8F1FF;
}

.about-course {
  background-color: white;
  border-radius: 16px;
}

/* ================================================================
   استایل‌های پلیر ویدیو
   ================================================================ */

.video-container {
  position: relative;
  width: 100%;
}

.video-controls {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.control-btn {
  background: transparent;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.progress-container {
  width: 85%;
  height: 5px;
  background: #333;
  margin-top: 8px;
  border-radius: 999px;
  overflow: hidden;
  position: absolute;
  bottom: 35px;
  left: 10px;
  direction: ltr;
}

.video-container:fullscreen {
  width: 100vw;
  height: 100vh;
  background: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.video-container:fullscreen .video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 0;
}

.progress-bar {
  height: 100%;
  background: #28a745;
  transition: width 0.2s linear;
}

.control-container {
  position: absolute;
  bottom: 20px;
  width: 90%;
  right: 10px;
}

/* ================================================================
   ریسپانسیو - تبلت و موبایل
   ================================================================ */

@media (max-width: 990px) {
  .vid-course {
    width: 93vw;
  }
  .faq-answer {
    padding: 0;
  }
  .wc-200 {
    width: 200px !important;
  }
  .control-btn {
    padding: 2px 3px;
  }
  .time-display {
    font-size: 12px;
  }
  .control-btn svg {
    width: 25px;
    height: 25px;
  }
  .progress-container {
    width: 73%;
  }
  .wc-180 {
    width: 185px !important;
  }
  .control-container {
    bottom: 20px;
  }
  .payment-btn {
    width: 335px;
  }
  .payment-container {
    width: 100% !important;
  }
}

/* ================================================================
   استایل‌های مودال‌ها
   ================================================================ */

.custom-exercise-modal .modal-content {
  border-radius: 20px;
  border: none;
}

.upload-box {
  border: 2px dashed #e0e0e0;
  border-radius: 15px;
  padding: 30px;
  cursor: pointer;
  background: #fcfcfc;
  transition: 0.3s;
}

.upload-box:hover {
  border-color: #28a745;
}

.submit-exercise-btn {
  background-color: #2BA769;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 50px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 150;
}

.bb-detail:last-child {
  border-bottom: none;
}

.faq-item:last-child {
  border-bottom: none;
}

.payment-btn {
  position: fixed;
  bottom: 0px;
  right: 0;
  width: 100vw;
  background: RGBA(247, 100, 80, 1);
  z-index: 150;
  background: linear-gradient(180deg, transparent 18%, rgba(255, 255, 255, 1) 74%);
}

.custom-success-modal .modal-content {
  border-radius: 25px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* ================================================================
   استایل‌های سیستم تور راهنما
   ================================================================ */

.tour-highlight-target {
  position: relative;
  z-index: 9999999 !important;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 0 10px rgba(255, 255, 255, 1), 0 0 0 15px #2ba769;
  transition: all 0.3s ease;
  display: inline-block;
}

.tour-overlay-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 999998;
  pointer-events: auto;
  direction: rtl;
}

.tour-popover-box {
  position: absolute;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  width: 280px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  z-index: 9999999;
  animation: tourBounce 0.4s ease-out;
}

.tour-popover-box h5 {
  font-size: 1.1rem;
  font-weight: bold;
  color: #202244;
  margin-bottom: 10px;
}

.tour-popover-box p {
  font-size: 0.9rem;
  color: #585858;
  line-height: 1.6;
  margin-bottom: 15px;
}

.btn-tour-next,
.btn-tour-finish {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  cursor: pointer;
  width: 100%;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-tour-next:hover,
.btn-tour-finish:hover {
  background-color: #218838;
}

.tour-popover-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

.tour-popover-box.eye-step {
  bottom: 30%;
  left: 10%;
}

.tour-popover-box.upload-step {
  bottom: 30%;
  left: 10%;
}

@keyframes tourBounce {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .tour-popover-box {
    position: fixed;
    bottom: 20px !important;
    left: 5% !important;
    right: 5% !important;
    width: 90% !important;
  }
  .tour-highlight-target {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 1), 0 0 0 10px #2ba769;
  }
}

/* ================================================================
   استایل‌های پلیر ویدیو (بخش اصلی)
   ================================================================ */

.video-player-wrapper {
  width: 100%;
  max-width: 1000px;
}

/* ====== کانتینر ویدیو ====== */
.video-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: black;
  border-radius: 12px;
  overflow: hidden;
}

.video-container video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  max-height: 80vh;
}

/* ====== حالت تمام صفحه ====== */
.video-container.full-screen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
  z-index: 9999 !important;
  background: black !important;
  overflow: hidden !important;
}

.video-container.full-screen video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  max-height: 100vh !important;
}

.video-container.full-screen .video-controls-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
}

/* ================================================================
   کنترل‌های ویدیو
   ================================================================ */

.video-controls-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  z-index: 100;
  opacity: 0;
  transition: opacity 150ms ease-in-out;
}

.video-controls-container::before {
  content: "";
  position: absolute;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, .75), transparent);
  width: 100%;
  aspect-ratio: 6 / 1;
  z-index: -1;
  pointer-events: none;
}

.video-container:hover .video-controls-container,
.video-container:focus-within .video-controls-container,
.video-container.paused .video-controls-container {
  opacity: 1;
}

.video-controls-container .controls {
  display: flex;
  gap: .5rem;
  padding: .25rem;
  align-items: center;
  flex-wrap: wrap;
  direction: ltr;
}

.video-controls-container .controls button {
  background: none;
  border: none;
  color: inherit;
  padding: 0;
  height: 30px;
  width: 30px;
  font-size: 1.1rem;
  cursor: pointer;
  opacity: .85;
  transition: opacity 150ms ease-in-out;
}

.video-controls-container .controls button:hover {
  opacity: 1;
}

.video-container.paused .pause-icon {
  display: none;
}

.video-container:not(.paused) .play-icon {
  display: none;
}

.video-container.full-screen .open {
  display: none;
}

.video-container:not(.full-screen) .close {
  display: none;
}

.volume-high-icon,
.volume-low-icon,
.volume-muted-icon {
  display: none;
}

.video-container[data-volume-level="high"] .volume-high-icon {
  display: block;
}

.video-container[data-volume-level="low"] .volume-low-icon {
  display: block;
}

.video-container[data-volume-level="muted"] .volume-muted-icon {
  display: block;
}

.volume-container {
  display: flex;
  align-items: center;
}

.volume-slider {
  width: 0;
  transform-origin: left;
  transform: scaleX(0);
  transition: width 150ms ease-in-out, transform 150ms ease-in-out;
}

.volume-container:hover .volume-slider,
.volume-slider:focus-within {
  width: 100px;
  transform: scaleX(1);
}

.duration-container {
  display: flex;
  align-items: center;
  gap: .25rem;
  flex-grow: 1;
  font-size: 0.9rem;
  font-family: sans-serif;
}

.video-controls-container .controls button.wide-btn {
  width: 50px;
}

/* ================================================================
   تایم‌لاین
   ================================================================ */

.timeline-container {
  height: 7px;
  margin-inline: .5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}

.timeline {
  background-color: rgba(100, 100, 100, .5);
  height: 3px;
  width: 100%;
  position: relative;
}

.timeline::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: calc(100% - var(--progress-position) * 100%);
  background-color: #159463;
  z-index: 2;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: calc(100% - var(--preview-position) * 100%);
  background-color: rgb(150, 150, 150);
  display: none;
  z-index: 1;
}

.thumb-indicator {
  --scale: 0;
  position: absolute;
  transform: translateX(-50%) scale(var(--scale));
  height: 200%;
  top: -50%;
  left: calc(var(--progress-position) * 100%);
  background-color: #159463;
  border-radius: 50%;
  transition: transform 150ms ease-in-out;
  aspect-ratio: 1 / 1;
  z-index: 3;
}

.video-container.scrubbing .timeline::before,
.timeline-container:hover .timeline::before {
  display: block;
}

.video-container.scrubbing .thumb-indicator,
.timeline-container:hover .thumb-indicator {
  --scale: 1;
}

.video-container.scrubbing .timeline,
.timeline-container:hover .timeline {
  height: 100%;
}

/* ================================================================
   فصل‌ها روی تایم‌لاین
   ================================================================ */

.chapters-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  pointer-events: none;
  z-index: 1;
  direction: ltr;
}

.chapter-segment {
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: opacity 0.2s;
  pointer-events: auto;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  opacity: 0.7;
}

.chapter-segment:hover {
  opacity: 1;
}

.chapter-segment[data-color="0"] {
  background: rgba(255, 59, 48, 0.5);
}
.chapter-segment[data-color="1"] {
  background: rgba(255, 149, 0, 0.5);
}
.chapter-segment[data-color="2"] {
  background: rgba(255, 204, 0, 0.5);
}
.chapter-segment[data-color="3"] {
  background: rgba(76, 217, 100, 0.5);
}
.chapter-segment[data-color="4"] {
  background: rgba(90, 200, 250, 0.5);
}
.chapter-segment[data-color="5"] {
  background: rgba(0, 122, 255, 0.5);
}
.chapter-segment[data-color="6"] {
  background: rgba(175, 82, 222, 0.5);
}
.chapter-segment[data-color="7"] {
  background: rgba(255, 45, 85, 0.5);
}

.chapter-segment .chapter-tooltip {
  position: absolute;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-family: sans-serif;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 10;
}

.chapter-segment:hover .chapter-tooltip {
  opacity: 1;
}

.chapter-tooltip .chapter-time {
  font-weight: bold;
  color: #ffd700;
  margin-right: 6px;
}

.chapter-tooltip .chapter-title-text {
  color: #eee;
}

/* ================================================================
   دکمه پلی بزرگ
   ================================================================ */

.big-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.7);
  border: 3px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  cursor: pointer;
  z-index: 50;
  display: none;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: white;
}

.big-play-btn:hover {
  background: #159463;
  transform: translate(-50%, -50%) scale(1.1);
  border-color: white;
}

.big-play-btn svg {
  width: 40px;
  height: 40px;
  fill: white;
}

.video-container.paused .big-play-btn {
  display: flex;
}

/* ================================================================
   استایل برای قفل بودن درس
   ================================================================ */

.timeline-container.locked {
  cursor: not-allowed;
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  pointer-events: none;
}

.lock-overlay span {
  font-size: 14px;
  color: white;
  background: rgba(0, 0, 0, 0.6);
  padding: 2px 8px;
  border-radius: 4px;
}

/* ================================================================
   توضیحات و بخش‌های ویدیو
   ================================================================ */

.video-description {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 16px 18px;
  margin-top: 12px;
  color: #f1f1f1;
  direction: rtl;
}

.description-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.video-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.description-body {
  padding-top: 12px;
}

.chapters-toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #2BA769;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 0;
  transition: color 0.2s;
  font-family: inherit;
}

.chapters-toggle-btn:hover {
  color: #2BA769;
}

.chapters-toggle-btn .arrow-icon {
  transition: transform 0.3s ease;
}

.chapters-toggle-btn.active .arrow-icon {
  transform: rotate(180deg);
}

.chapters-list {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.3s ease, margin 0.3s ease;
  opacity: 0;
  margin: 0;
}

.chapters-list.active {
  max-height: 600px;
  opacity: 1;
  margin: 8px 0 4px 0;
}

.chapters-list-inner {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #FF9800;
}

.chapter-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s;
  color: #000;
  font-size: 14px;
  border-left: 3px solid transparent;
  background: transparent;
  border-bottom: 1px solid #FF9800;
}

.chapter-item:last-child {
  border-bottom: none;
}

.chapter-item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.chapter-item.active {
  background: #FFF3E0;
  border-left-color: #FF9800;
  color: #000;
}

.chapter-item .chapter-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chapter-item .chapter-time-badge {
  font-weight: 600;
  color: #000;
  font-size: 13px;
  min-width: 44px;
  font-feature-settings: "tnum";
}

.chapter-item .chapter-title-text {
  flex: 1 1;
  line-height: 1.3;
}

.chapter-item .chapter-duration {
  font-size: 12px;
  color: #666;
}

.description-text {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #252525;
  color: #bbb;
  font-size: 14px;
  line-height: 1.7;
}

.description-text p {
  margin: 4px 0;
}

.description-text p:first-child {
  margin-top: 0;
}

.description-text p:last-child {
  margin-bottom: 0;
}

/* ================================================================
   استایل‌های مخصوص iOS برای تمام صفحه
   ================================================================ */

/* کلاس برای بدنه در زمان تمام صفحه iOS */
body.ios-fullscreen-active {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
}

body.fullscreen-active {
  overflow: hidden !important;
}

/* استایل‌های مخصوص iOS تمام صفحه */
.video-container.ios-fullscreen-transition {
  transition: all 0.3s ease;
}

/* مخفی کردن کنترل‌های پیش‌فرض iOS */
.video-container video::-webkit-media-controls {
  display: none !important;
}

.video-container video::-webkit-media-controls-enclosure {
  display: none !important;
}

.video-container video::-webkit-media-controls-panel {
  display: none !important;
}

.video-container video::-webkit-media-controls-play-button {
  display: none !important;
}

.video-container video::-webkit-media-controls-volume-slider {
  display: none !important;
}

.video-container video::-webkit-media-controls-mute-button {
  display: none !important;
}

.video-container video::-webkit-media-controls-timeline {
  display: none !important;
}

.video-container video::-webkit-media-controls-current-time-display {
  display: none !important;
}

.video-container video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

.video-container video::-webkit-media-controls-seek-back-button {
  display: none !important;
}

.video-container video::-webkit-media-controls-seek-forward-button {
  display: none !important;
}

.video-container video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}

/* استایل برای کنترل‌های سفارشی در iOS */
.video-container[data-is-ios="true"] .video-controls-container {
  z-index: 10000 !important;
}

.video-container[data-is-ios="true"].full-screen .video-controls-container {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 10000 !important;
}

/* ================================================================
   ریسپانسیو - تبلت
   ================================================================ */

@media (max-width: 768px) {
  .video-description {
    padding: 12px 14px;
    border-radius: 8px;
  }

  .video-title {
    font-size: 15px;
  }

  .chapter-item {
    font-size: 13px;
    padding: 8px 12px;
    gap: 10px;
  }

  .chapter-item .chapter-time-badge {
    min-width: 36px;
    font-size: 12px;
  }

  .big-play-btn {
    width: 60px;
    height: 60px;
  }
  .big-play-btn svg {
    width: 30px;
    height: 30px;
  }

  /* موبایل تمام صفحه */
  .video-container.full-screen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
    z-index: 9999 !important;
    background: #000 !important;
    overflow: hidden !important;
  }

  .video-container.full-screen video {
    object-fit: contain !important;
    width: 100% !important;
    height: 100% !important;
    max-height: 100vh !important;
  }

  .video-container.full-screen .video-controls-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 101;
  }
}

/* ================================================================
   ریسپانسیو - موبایل کوچک (آیفون)
   ================================================================ */

@media (max-width: 480px) {
  .video-container.full-screen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
    z-index: 9999 !important;
    background: #000 !important;
    overflow: hidden !important;
  }

  .video-container.full-screen video {
    object-fit: contain !important;
    width: 100% !important;
    height: 100% !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }

  .video-container.full-screen .video-controls-container {
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 101 !important;
  }

  .video-container.full-screen .controls button {
    height: 24px !important;
    width: 24px !important;
    font-size: 0.9rem !important;
  }

  .video-container.full-screen .duration-container {
    font-size: 0.75rem !important;
  }

  .video-container.full-screen .volume-slider {
    width: 60px !important;
  }

  .video-container.full-screen .big-play-btn {
    width: 50px !important;
    height: 50px !important;
  }
  .video-container.full-screen .big-play-btn svg {
    width: 25px !important;
    height: 25px !important;
  }
}

/* ================================================================
   حالت Landscape در موبایل
   ================================================================ */

@media (max-width: 768px) and (orientation: landscape) {
  .video-container.full-screen video {
    object-fit: contain !important;
    width: 100% !important;
    height: 100% !important;
    max-height: 100vh !important;
  }

  .video-container.full-screen .controls button {
    height: 28px !important;
    width: 28px !important;
  }
}

/* ================================================================
   پشتیبانی از Safari در iOS
   ================================================================ */

@supports (-webkit-touch-callout: none) {
  /* iOS Safari */
  .video-container.full-screen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    z-index: 9999 !important;
    background: #000 !important;
    border-radius: 0 !important;
    overflow: hidden !important;
  }

  .video-container.full-screen video {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }

  .video-container.full-screen video::-webkit-media-controls {
    display: none !important;
  }

  .video-container.full-screen video::-webkit-media-controls-enclosure {
    display: none !important;
  }
}

/* ================================================================
   استایل‌های ریپلای (پیام‌ها)
   ================================================================ */

.message-wrapper {
  margin-bottom: 5px;
}

.reply-icon-btn {
  position: absolute;
  bottom: 5px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 0;
  z-index: 5;
  transition: all 0.2s;
}

.reply-icon-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 3px 8px rgba(43, 167, 105, 0.3) !important;
  border-color: #2BA769 !important;
}

.show-replies-btn {
  background: none;
  border: 1px solid #2BA769;
  border-radius: 15px;
  padding: 2px 10px;
  font-size: 0.7rem;
  color: #2BA769;
  cursor: pointer;
  margin-top: 5px;
  display: block;
  width: fit-content;
  background-color: rgba(43, 167, 105, 0.1);
  transition: all 0.2s;
}

.show-replies-btn:hover {
  background-color: #2BA769;
  color: white;
}

.replies-wrapper {
  margin-right: 30px;
  margin-top: 2px;
  padding-right: 10px;
  border-right: 2px solid #2BA769;
}

.replies-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.reply-item {
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  position: relative;
  max-width: 80%;
}

.reply-sender-name {
  font-size: 0.65rem;
  font-weight: bold;
  margin-bottom: 2px;
  opacity: 0.8;
}

.reply-message {
  word-break: break-word;
}

.reply-attachment {
  margin-top: 3px;
}

.reply-attachment a {
  color: inherit;
  text-decoration: none;
  font-size: 0.75rem;
  opacity: 0.8;
}

.reply-attachment a:hover {
  text-decoration: underline;
}

.reply-time {
  font-size: 0.6rem;
  opacity: 0.7;
  display: block;
  text-align: left;
  margin-top: 2px;
}

.reply-box {
  position: fixed;
  bottom: 80px;
  left: 0;
  right: 0;
  background: #f0f2f5;
  padding: 8px 16px;
  border-right: 3px solid #2BA769;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  animation: slideUp 0.2s ease;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.reply-box-content {
  flex: 1 1;
  min-width: 0;
}

.reply-box-label {
  font-size: 12px;
  color: #2BA769;
  font-weight: bold;
  margin-bottom: 2px;
}

.reply-box-message {
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: italic;
}

.reply-box-close {
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0 8px;
}

.reply-box-close:hover {
  color: #333;
}

.selected-file {
  position: fixed;
  bottom: 80px;
  left: 20px;
  right: 20px;
  background-color: white;
  padding: 5px 15px;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 11;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #555;
}

.selected-file button {
  padding: 0 5px;
  font-size: 1rem;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 990px) {
  .replies-wrapper {
    margin-right: 15px;
  }

  .reply-item {
    max-width: 90%;
  }

  .reply-box {
    bottom: 75px;
    padding: 6px 12px;
  }

  .selected-file {
    bottom: 75px;
    font-size: 0.8rem;
    padding: 4px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/coursedetail.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;;qEAEqE;;AAErE;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,iEAAiE;EACjE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gEAAgE;EAClE;AACF;;AAEA;;qEAEqE;;AAErE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oEAAoE;EACpE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,gEAAgE;AAClE;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;;qEAEqE;;AAErE;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,mDAAmD;EACnD,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,kDAAkD;EAClD,oCAAoC;EACpC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,SAAS;EACT,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qEAAqE;EACrE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;qEAEqE;;AAErE,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;qEAEqE;;AAErE;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;EACd;AACF;;AAEA;;qEAEqE;;AAErE;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;qEAEqE;;AAErE;EACE;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;;qEAEqE;;AAErE;EACE,eAAe;EACf;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":["/* ================================================================\n   استایل‌های اصلی صفحه جزئیات دوره\n   ================================================================ */\n\n.vid-course {\n  width: 70vw;\n}\n\n.coursed-container {\n  background-color: white;\n  border-radius: 16px;\n}\n\n.mobile-scroll-buttons {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n  padding-bottom: 10px;\n  background-color: white;\n  border-radius: 0 0 16px 16px;\n  box-shadow: 0px 3px 10px #e0e0e0;\n}\n\n.mobile-scroll-buttons .course-btn {\n  flex: 0 0 auto;\n}\n\n.mobile-scroll-buttons {\n  scrollbar-width: thin;\n  scrollbar-color: #28a745 #e0e0e0;\n}\n\n.mobile-scroll-buttons::-webkit-scrollbar {\n  height: 8px;\n}\n\n.mobile-scroll-buttons::-webkit-scrollbar-track {\n  background: #e0e0e0;\n  border-radius: 10px;\n}\n\n.mobile-scroll-buttons::-webkit-scrollbar-thumb {\n  background: #28a745;\n  border-radius: 10px;\n}\n\n.upd-sz {\n  width: 120px;\n  background-color: #E8F1FF;\n  color: rgba(0, 0, 0, 0.633);\n}\n\n.faq-item {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.faq-question {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.faq-answer-wrapper {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.faq-answer-wrapper.open {\n  grid-template-rows: 1fr;\n}\n\n.faq-answer {\n  overflow: hidden;\n}\n\n.time-session {\n  font-size: 13px;\n  color: #28a745;\n}\n\n.number-part {\n  background-color: #D8EEE3;\n  border: 2px solid #95D3B4;\n  width: 46px;\n  height: 46px;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold !important;\n}\n\n.fs-little {\n  font-size: 13px;\n}\n\n.bb-detail {\n  border-bottom: 1px solid #E8F1FF;\n}\n\n.about-course {\n  background-color: white;\n  border-radius: 16px;\n}\n\n/* ================================================================\n   استایل‌های پلیر ویدیو\n   ================================================================ */\n\n.video-container {\n  position: relative;\n  width: 100%;\n}\n\n.video-controls {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.control-btn {\n  background: transparent;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.progress-container {\n  width: 85%;\n  height: 5px;\n  background: #333;\n  margin-top: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  position: absolute;\n  bottom: 35px;\n  left: 10px;\n  direction: ltr;\n}\n\n.video-container:fullscreen {\n  width: 100vw;\n  height: 100vh;\n  background: black;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.video-container:fullscreen .video-element {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 0;\n}\n\n.progress-bar {\n  height: 100%;\n  background: #28a745;\n  transition: width 0.2s linear;\n}\n\n.control-container {\n  position: absolute;\n  bottom: 20px;\n  width: 90%;\n  right: 10px;\n}\n\n/* ================================================================\n   ریسپانسیو - تبلت و موبایل\n   ================================================================ */\n\n@media (max-width: 990px) {\n  .vid-course {\n    width: 93vw;\n  }\n  .faq-answer {\n    padding: 0;\n  }\n  .wc-200 {\n    width: 200px !important;\n  }\n  .control-btn {\n    padding: 2px 3px;\n  }\n  .time-display {\n    font-size: 12px;\n  }\n  .control-btn svg {\n    width: 25px;\n    height: 25px;\n  }\n  .progress-container {\n    width: 73%;\n  }\n  .wc-180 {\n    width: 185px !important;\n  }\n  .control-container {\n    bottom: 20px;\n  }\n  .payment-btn {\n    width: 335px;\n  }\n  .payment-container {\n    width: 100% !important;\n  }\n}\n\n/* ================================================================\n   استایل‌های مودال‌ها\n   ================================================================ */\n\n.custom-exercise-modal .modal-content {\n  border-radius: 20px;\n  border: none;\n}\n\n.upload-box {\n  border: 2px dashed #e0e0e0;\n  border-radius: 15px;\n  padding: 30px;\n  cursor: pointer;\n  background: #fcfcfc;\n  transition: 0.3s;\n}\n\n.upload-box:hover {\n  border-color: #28a745;\n}\n\n.submit-exercise-btn {\n  background-color: #2BA769;\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 50px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 150;\n}\n\n.bb-detail:last-child {\n  border-bottom: none;\n}\n\n.faq-item:last-child {\n  border-bottom: none;\n}\n\n.payment-btn {\n  position: fixed;\n  bottom: 0px;\n  right: 0;\n  width: 100vw;\n  background: RGBA(247, 100, 80, 1);\n  z-index: 150;\n  background: linear-gradient(180deg, transparent 18%, rgba(255, 255, 255, 1) 74%);\n}\n\n.custom-success-modal .modal-content {\n  border-radius: 25px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n/* ================================================================\n   استایل‌های سیستم تور راهنما\n   ================================================================ */\n\n.tour-highlight-target {\n  position: relative;\n  z-index: 9999999 !important;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 0 0 10px rgba(255, 255, 255, 1), 0 0 0 15px #2ba769;\n  transition: all 0.3s ease;\n  display: inline-block;\n}\n\n.tour-overlay-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.65);\n  z-index: 999998;\n  pointer-events: auto;\n  direction: rtl;\n}\n\n.tour-popover-box {\n  position: absolute;\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 20px;\n  width: 280px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n  z-index: 9999999;\n  animation: tourBounce 0.4s ease-out;\n}\n\n.tour-popover-box h5 {\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: #202244;\n  margin-bottom: 10px;\n}\n\n.tour-popover-box p {\n  font-size: 0.9rem;\n  color: #585858;\n  line-height: 1.6;\n  margin-bottom: 15px;\n}\n\n.btn-tour-next,\n.btn-tour-finish {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  width: 100%;\n  font-weight: bold;\n  transition: background-color 0.2s;\n}\n\n.btn-tour-next:hover,\n.btn-tour-finish:hover {\n  background-color: #218838;\n}\n\n.tour-popover-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n}\n\n.tour-popover-box.eye-step {\n  bottom: 30%;\n  left: 10%;\n}\n\n.tour-popover-box.upload-step {\n  bottom: 30%;\n  left: 10%;\n}\n\n@keyframes tourBounce {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .tour-popover-box {\n    position: fixed;\n    bottom: 20px !important;\n    left: 5% !important;\n    right: 5% !important;\n    width: 90% !important;\n  }\n  .tour-highlight-target {\n    box-shadow: 0 0 0 6px rgba(255, 255, 255, 1), 0 0 0 10px #2ba769;\n  }\n}\n\n/* ================================================================\n   استایل‌های پلیر ویدیو (بخش اصلی)\n   ================================================================ */\n\n.video-player-wrapper {\n  width: 100%;\n  max-width: 1000px;\n}\n\n/* ====== کانتینر ویدیو ====== */\n.video-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: black;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.video-container video {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  max-height: 80vh;\n}\n\n/* ====== حالت تمام صفحه ====== */\n.video-container.full-screen {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  max-height: 100vh !important;\n  border-radius: 0 !important;\n  z-index: 9999 !important;\n  background: black !important;\n  overflow: hidden !important;\n}\n\n.video-container.full-screen video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain !important;\n  max-height: 100vh !important;\n}\n\n.video-container.full-screen .video-controls-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 101;\n}\n\n/* ================================================================\n   کنترل‌های ویدیو\n   ================================================================ */\n\n.video-controls-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  color: white;\n  z-index: 100;\n  opacity: 0;\n  transition: opacity 150ms ease-in-out;\n}\n\n.video-controls-container::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, .75), transparent);\n  width: 100%;\n  aspect-ratio: 6 / 1;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.video-container:hover .video-controls-container,\n.video-container:focus-within .video-controls-container,\n.video-container.paused .video-controls-container {\n  opacity: 1;\n}\n\n.video-controls-container .controls {\n  display: flex;\n  gap: .5rem;\n  padding: .25rem;\n  align-items: center;\n  flex-wrap: wrap;\n  direction: ltr;\n}\n\n.video-controls-container .controls button {\n  background: none;\n  border: none;\n  color: inherit;\n  padding: 0;\n  height: 30px;\n  width: 30px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  opacity: .85;\n  transition: opacity 150ms ease-in-out;\n}\n\n.video-controls-container .controls button:hover {\n  opacity: 1;\n}\n\n.video-container.paused .pause-icon {\n  display: none;\n}\n\n.video-container:not(.paused) .play-icon {\n  display: none;\n}\n\n.video-container.full-screen .open {\n  display: none;\n}\n\n.video-container:not(.full-screen) .close {\n  display: none;\n}\n\n.volume-high-icon,\n.volume-low-icon,\n.volume-muted-icon {\n  display: none;\n}\n\n.video-container[data-volume-level=\"high\"] .volume-high-icon {\n  display: block;\n}\n\n.video-container[data-volume-level=\"low\"] .volume-low-icon {\n  display: block;\n}\n\n.video-container[data-volume-level=\"muted\"] .volume-muted-icon {\n  display: block;\n}\n\n.volume-container {\n  display: flex;\n  align-items: center;\n}\n\n.volume-slider {\n  width: 0;\n  transform-origin: left;\n  transform: scaleX(0);\n  transition: width 150ms ease-in-out, transform 150ms ease-in-out;\n}\n\n.volume-container:hover .volume-slider,\n.volume-slider:focus-within {\n  width: 100px;\n  transform: scaleX(1);\n}\n\n.duration-container {\n  display: flex;\n  align-items: center;\n  gap: .25rem;\n  flex-grow: 1;\n  font-size: 0.9rem;\n  font-family: sans-serif;\n}\n\n.video-controls-container .controls button.wide-btn {\n  width: 50px;\n}\n\n/* ================================================================\n   تایم‌لاین\n   ================================================================ */\n\n.timeline-container {\n  height: 7px;\n  margin-inline: .5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.timeline {\n  background-color: rgba(100, 100, 100, .5);\n  height: 3px;\n  width: 100%;\n  position: relative;\n}\n\n.timeline::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: calc(100% - var(--progress-position) * 100%);\n  background-color: #159463;\n  z-index: 2;\n}\n\n.timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: calc(100% - var(--preview-position) * 100%);\n  background-color: rgb(150, 150, 150);\n  display: none;\n  z-index: 1;\n}\n\n.thumb-indicator {\n  --scale: 0;\n  position: absolute;\n  transform: translateX(-50%) scale(var(--scale));\n  height: 200%;\n  top: -50%;\n  left: calc(var(--progress-position) * 100%);\n  background-color: #159463;\n  border-radius: 50%;\n  transition: transform 150ms ease-in-out;\n  aspect-ratio: 1 / 1;\n  z-index: 3;\n}\n\n.video-container.scrubbing .timeline::before,\n.timeline-container:hover .timeline::before {\n  display: block;\n}\n\n.video-container.scrubbing .thumb-indicator,\n.timeline-container:hover .thumb-indicator {\n  --scale: 1;\n}\n\n.video-container.scrubbing .timeline,\n.timeline-container:hover .timeline {\n  height: 100%;\n}\n\n/* ================================================================\n   فصل‌ها روی تایم‌لاین\n   ================================================================ */\n\n.chapters-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  pointer-events: none;\n  z-index: 1;\n  direction: ltr;\n}\n\n.chapter-segment {\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  transition: opacity 0.2s;\n  pointer-events: auto;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n  opacity: 0.7;\n}\n\n.chapter-segment:hover {\n  opacity: 1;\n}\n\n.chapter-segment[data-color=\"0\"] {\n  background: rgba(255, 59, 48, 0.5);\n}\n.chapter-segment[data-color=\"1\"] {\n  background: rgba(255, 149, 0, 0.5);\n}\n.chapter-segment[data-color=\"2\"] {\n  background: rgba(255, 204, 0, 0.5);\n}\n.chapter-segment[data-color=\"3\"] {\n  background: rgba(76, 217, 100, 0.5);\n}\n.chapter-segment[data-color=\"4\"] {\n  background: rgba(90, 200, 250, 0.5);\n}\n.chapter-segment[data-color=\"5\"] {\n  background: rgba(0, 122, 255, 0.5);\n}\n.chapter-segment[data-color=\"6\"] {\n  background: rgba(175, 82, 222, 0.5);\n}\n.chapter-segment[data-color=\"7\"] {\n  background: rgba(255, 45, 85, 0.5);\n}\n\n.chapter-segment .chapter-tooltip {\n  position: absolute;\n  bottom: 150%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.85);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: sans-serif;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  z-index: 10;\n}\n\n.chapter-segment:hover .chapter-tooltip {\n  opacity: 1;\n}\n\n.chapter-tooltip .chapter-time {\n  font-weight: bold;\n  color: #ffd700;\n  margin-right: 6px;\n}\n\n.chapter-tooltip .chapter-title-text {\n  color: #eee;\n}\n\n/* ================================================================\n   دکمه پلی بزرگ\n   ================================================================ */\n\n.big-play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80px;\n  height: 80px;\n  background: rgba(0, 0, 0, 0.7);\n  border: 3px solid rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 50;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  color: white;\n}\n\n.big-play-btn:hover {\n  background: #159463;\n  transform: translate(-50%, -50%) scale(1.1);\n  border-color: white;\n}\n\n.big-play-btn svg {\n  width: 40px;\n  height: 40px;\n  fill: white;\n}\n\n.video-container.paused .big-play-btn {\n  display: flex;\n}\n\n/* ================================================================\n   استایل برای قفل بودن درس\n   ================================================================ */\n\n.timeline-container.locked {\n  cursor: not-allowed;\n}\n\n.lock-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n  pointer-events: none;\n}\n\n.lock-overlay span {\n  font-size: 14px;\n  color: white;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* ================================================================\n   توضیحات و بخش‌های ویدیو\n   ================================================================ */\n\n.video-description {\n  background: #FFFFFF;\n  border-radius: 12px;\n  padding: 16px 18px;\n  margin-top: 12px;\n  color: #f1f1f1;\n  direction: rtl;\n}\n\n.description-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.video-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n}\n\n.description-body {\n  padding-top: 12px;\n}\n\n.chapters-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  color: #2BA769;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 6px 0;\n  transition: color 0.2s;\n  font-family: inherit;\n}\n\n.chapters-toggle-btn:hover {\n  color: #2BA769;\n}\n\n.chapters-toggle-btn .arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.chapters-toggle-btn.active .arrow-icon {\n  transform: rotate(180deg);\n}\n\n.chapters-list {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.4s ease, opacity 0.3s ease, margin 0.3s ease;\n  opacity: 0;\n  margin: 0;\n}\n\n.chapters-list.active {\n  max-height: 600px;\n  opacity: 1;\n  margin: 8px 0 4px 0;\n}\n\n.chapters-list-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #FF9800;\n}\n\n.chapter-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: background 0.15s;\n  color: #000;\n  font-size: 14px;\n  border-left: 3px solid transparent;\n  background: transparent;\n  border-bottom: 1px solid #FF9800;\n}\n\n.chapter-item:last-child {\n  border-bottom: none;\n}\n\n.chapter-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.chapter-item.active {\n  background: #FFF3E0;\n  border-left-color: #FF9800;\n  color: #000;\n}\n\n.chapter-item .chapter-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.chapter-item .chapter-time-badge {\n  font-weight: 600;\n  color: #000;\n  font-size: 13px;\n  min-width: 44px;\n  font-feature-settings: \"tnum\";\n}\n\n.chapter-item .chapter-title-text {\n  flex: 1;\n  line-height: 1.3;\n}\n\n.chapter-item .chapter-duration {\n  font-size: 12px;\n  color: #666;\n}\n\n.description-text {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #252525;\n  color: #bbb;\n  font-size: 14px;\n  line-height: 1.7;\n}\n\n.description-text p {\n  margin: 4px 0;\n}\n\n.description-text p:first-child {\n  margin-top: 0;\n}\n\n.description-text p:last-child {\n  margin-bottom: 0;\n}\n\n/* ================================================================\n   استایل‌های مخصوص iOS برای تمام صفحه\n   ================================================================ */\n\n/* کلاس برای بدنه در زمان تمام صفحه iOS */\nbody.ios-fullscreen-active {\n  overflow: hidden !important;\n  position: fixed !important;\n  width: 100% !important;\n  height: 100% !important;\n  top: 0 !important;\n  left: 0 !important;\n}\n\nbody.fullscreen-active {\n  overflow: hidden !important;\n}\n\n/* استایل‌های مخصوص iOS تمام صفحه */\n.video-container.ios-fullscreen-transition {\n  transition: all 0.3s ease;\n}\n\n/* مخفی کردن کنترل‌های پیش‌فرض iOS */\n.video-container video::-webkit-media-controls {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-enclosure {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-panel {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-play-button {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-volume-slider {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-mute-button {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-timeline {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-current-time-display {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-time-remaining-display {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-seek-back-button {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-seek-forward-button {\n  display: none !important;\n}\n\n.video-container video::-webkit-media-controls-fullscreen-button {\n  display: none !important;\n}\n\n/* استایل برای کنترل‌های سفارشی در iOS */\n.video-container[data-is-ios=\"true\"] .video-controls-container {\n  z-index: 10000 !important;\n}\n\n.video-container[data-is-ios=\"true\"].full-screen .video-controls-container {\n  position: absolute !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  z-index: 10000 !important;\n}\n\n/* ================================================================\n   ریسپانسیو - تبلت\n   ================================================================ */\n\n@media (max-width: 768px) {\n  .video-description {\n    padding: 12px 14px;\n    border-radius: 8px;\n  }\n\n  .video-title {\n    font-size: 15px;\n  }\n\n  .chapter-item {\n    font-size: 13px;\n    padding: 8px 12px;\n    gap: 10px;\n  }\n\n  .chapter-item .chapter-time-badge {\n    min-width: 36px;\n    font-size: 12px;\n  }\n\n  .big-play-btn {\n    width: 60px;\n    height: 60px;\n  }\n  .big-play-btn svg {\n    width: 30px;\n    height: 30px;\n  }\n\n  /* موبایل تمام صفحه */\n  .video-container.full-screen {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    border-radius: 0 !important;\n    z-index: 9999 !important;\n    background: #000 !important;\n    overflow: hidden !important;\n  }\n\n  .video-container.full-screen video {\n    object-fit: contain !important;\n    width: 100% !important;\n    height: 100% !important;\n    max-height: 100vh !important;\n  }\n\n  .video-container.full-screen .video-controls-container {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 101;\n  }\n}\n\n/* ================================================================\n   ریسپانسیو - موبایل کوچک (آیفون)\n   ================================================================ */\n\n@media (max-width: 480px) {\n  .video-container.full-screen {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    border-radius: 0 !important;\n    z-index: 9999 !important;\n    background: #000 !important;\n    overflow: hidden !important;\n  }\n\n  .video-container.full-screen video {\n    object-fit: contain !important;\n    width: 100% !important;\n    height: 100% !important;\n    max-height: 100vh !important;\n    border-radius: 0 !important;\n  }\n\n  .video-container.full-screen .video-controls-container {\n    position: absolute !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 101 !important;\n  }\n\n  .video-container.full-screen .controls button {\n    height: 24px !important;\n    width: 24px !important;\n    font-size: 0.9rem !important;\n  }\n\n  .video-container.full-screen .duration-container {\n    font-size: 0.75rem !important;\n  }\n\n  .video-container.full-screen .volume-slider {\n    width: 60px !important;\n  }\n\n  .video-container.full-screen .big-play-btn {\n    width: 50px !important;\n    height: 50px !important;\n  }\n  .video-container.full-screen .big-play-btn svg {\n    width: 25px !important;\n    height: 25px !important;\n  }\n}\n\n/* ================================================================\n   حالت Landscape در موبایل\n   ================================================================ */\n\n@media (max-width: 768px) and (orientation: landscape) {\n  .video-container.full-screen video {\n    object-fit: contain !important;\n    width: 100% !important;\n    height: 100% !important;\n    max-height: 100vh !important;\n  }\n\n  .video-container.full-screen .controls button {\n    height: 28px !important;\n    width: 28px !important;\n  }\n}\n\n/* ================================================================\n   پشتیبانی از Safari در iOS\n   ================================================================ */\n\n@supports (-webkit-touch-callout: none) {\n  /* iOS Safari */\n  .video-container.full-screen {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    z-index: 9999 !important;\n    background: #000 !important;\n    border-radius: 0 !important;\n    overflow: hidden !important;\n  }\n\n  .video-container.full-screen video {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: contain !important;\n    max-height: 100vh !important;\n    border-radius: 0 !important;\n  }\n\n  .video-container.full-screen video::-webkit-media-controls {\n    display: none !important;\n  }\n\n  .video-container.full-screen video::-webkit-media-controls-enclosure {\n    display: none !important;\n  }\n}\n\n/* ================================================================\n   استایل‌های ریپلای (پیام‌ها)\n   ================================================================ */\n\n.message-wrapper {\n  margin-bottom: 5px;\n}\n\n.reply-icon-btn {\n  position: absolute;\n  bottom: 5px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  z-index: 5;\n  transition: all 0.2s;\n}\n\n.reply-icon-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 3px 8px rgba(43, 167, 105, 0.3) !important;\n  border-color: #2BA769 !important;\n}\n\n.show-replies-btn {\n  background: none;\n  border: 1px solid #2BA769;\n  border-radius: 15px;\n  padding: 2px 10px;\n  font-size: 0.7rem;\n  color: #2BA769;\n  cursor: pointer;\n  margin-top: 5px;\n  display: block;\n  width: fit-content;\n  background-color: rgba(43, 167, 105, 0.1);\n  transition: all 0.2s;\n}\n\n.show-replies-btn:hover {\n  background-color: #2BA769;\n  color: white;\n}\n\n.replies-wrapper {\n  margin-right: 30px;\n  margin-top: 2px;\n  padding-right: 10px;\n  border-right: 2px solid #2BA769;\n}\n\n.replies-container {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.reply-item {\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  position: relative;\n  max-width: 80%;\n}\n\n.reply-sender-name {\n  font-size: 0.65rem;\n  font-weight: bold;\n  margin-bottom: 2px;\n  opacity: 0.8;\n}\n\n.reply-message {\n  word-break: break-word;\n}\n\n.reply-attachment {\n  margin-top: 3px;\n}\n\n.reply-attachment a {\n  color: inherit;\n  text-decoration: none;\n  font-size: 0.75rem;\n  opacity: 0.8;\n}\n\n.reply-attachment a:hover {\n  text-decoration: underline;\n}\n\n.reply-time {\n  font-size: 0.6rem;\n  opacity: 0.7;\n  display: block;\n  text-align: left;\n  margin-top: 2px;\n}\n\n.reply-box {\n  position: fixed;\n  bottom: 80px;\n  left: 0;\n  right: 0;\n  background: #f0f2f5;\n  padding: 8px 16px;\n  border-right: 3px solid #2BA769;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 10;\n  animation: slideUp 0.2s ease;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.reply-box-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.reply-box-label {\n  font-size: 12px;\n  color: #2BA769;\n  font-weight: bold;\n  margin-bottom: 2px;\n}\n\n.reply-box-message {\n  font-size: 13px;\n  color: #555;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-style: italic;\n}\n\n.reply-box-close {\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0 8px;\n}\n\n.reply-box-close:hover {\n  color: #333;\n}\n\n.selected-file {\n  position: fixed;\n  bottom: 80px;\n  left: 20px;\n  right: 20px;\n  background-color: white;\n  padding: 5px 15px;\n  border-radius: 20px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  z-index: 11;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.selected-file button {\n  padding: 0 5px;\n  font-size: 1rem;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 990px) {\n  .replies-wrapper {\n    margin-right: 15px;\n  }\n\n  .reply-item {\n    max-width: 90%;\n  }\n\n  .reply-box {\n    bottom: 75px;\n    padding: 6px 12px;\n  }\n\n  .selected-file {\n    bottom: 75px;\n    font-size: 0.8rem;\n    padding: 4px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
